// extracted by mini-css-extract-plugin
export var black = "_2c-6";
export var brand = "_2c-1";
export var ddefault = "_2c-0";
export var error = "_2c-3";
export var gray = "_2c-2";
export var highContrast = "_2c-8";
export var outline = "_2c-7";
export var success = "_2c-5";
export var warning = "_2c-4";